/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Kaiserin_Friedrich_Gymnasium3Inputs */

const en__field_enum_kaiserin_friedrich_gymnasium3 = /** @type {(inputs: _Field_Enum_Kaiserin_Friedrich_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bad Homburg`)
};

const de__field_enum_kaiserin_friedrich_gymnasium3 = /** @type {(inputs: _Field_Enum_Kaiserin_Friedrich_Gymnasium3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaiserin-Friedrich-Gymnasium`)
};

/**
* | output |
* | --- |
* | "Bad Homburg" |
*
* @param {_Field_Enum_Kaiserin_Friedrich_Gymnasium3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_kaiserin_friedrich_gymnasium3 = /** @type {((inputs?: _Field_Enum_Kaiserin_Friedrich_Gymnasium3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Kaiserin_Friedrich_Gymnasium3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_kaiserin_friedrich_gymnasium3(inputs)
	return de__field_enum_kaiserin_friedrich_gymnasium3(inputs)
});
export { _field_enum_kaiserin_friedrich_gymnasium3 as "_field_enum_Kaiserin_Friedrich_Gymnasium" }